import Utils from "../utils/Utils";

const vendorAvailabilityController = {
  getVendorsAvailability: ({
    categoryType,
    page = 1,
    promotionType,
    region,
    search,
    size = 10,
    storeStatus,
    jwt,
    Authorization,
  } = {}) => {
    const params = new URLSearchParams();

    if (categoryType) params.append("categoryType", categoryType);
    params.append("page", page);
    if (promotionType) params.append("promotionType", promotionType);
    if (region) params.append("region", region);
    if (search) params.append("search", search);
    params.append("size", size);
    if (storeStatus) params.append("storeStatus", storeStatus);

    return Utils.controller(
      "api/vendor-availability/v1/getVendorsAvailability",
      "",
      "GET",
      params.toString(),
      true,
      jwt || Authorization || "",
      true,
    );
  },
};

export default vendorAvailabilityController;
